<template>
  <vs-col vs-offset="1" class="mx-4 mt-6" v-if="logMessages">
    <vs-row v-if="logMessages.created.userName">
      <label class="text-log" v-if="logMessages.created.comments"
        >{{ $t('created_by_e') }} {{ logMessages.created.userName }} ({{
          logMessages.created.comments
        }}) {{ $t('on') }}
        {{ formatDate(logMessages.created.date, 'DD/MM/YYYY HH:MM:SS') }}</label
      >
      <label class="text-log" v-else
        >{{ $t('created_by_e') }} {{ logMessages.created.userName }}
        {{ $t('on') }}
        {{ formatDate(logMessages.created.date, 'DD/MM/YYYY HH:MM:SS') }}</label
      >
    </vs-row>
    <vs-row
      v-if="
        logMessages.classified.userName &&
        statusId != 2 &&
        statusId != 4 &&
        statusId != 7
      "
    >
      <label class="text-log">
        {{ $t('classified_by_e') }} {{ logMessages.classified.userName }}
        {{ $t('on') }}
        {{
          formatDate(logMessages.classified.date, 'DD/MM/YYYY HH:MM:SS')
        }}</label
      >
    </vs-row>
    <vs-row v-if="logMessages.rejected.userName">
      <label class="text-log"
        >{{ $t('rejected_by') }} {{ logMessages.rejected.userName }}
        {{ $t('on') }}
        {{
          formatDate(logMessages.rejected.date, 'DD/MM/YYYY HH:MM:SS')
        }}</label
      >
    </vs-row>
    <vs-row v-if="logMessages.canceled.userName">
      <label class="text-log"
        >{{ $t('canceled_by') }} {{ logMessages.canceled.userName }}
        {{ $t('on') }}
        {{
          formatDate(logMessages.canceled.date, 'DD/MM/YYYY HH:MM:SS')
        }}</label
      >
    </vs-row>
    <vs-row v-if="logMessages.deleted.userName">
      <label class="text-log"
        >{{ $t('deleted_by') }} {{ logMessages.deleted.userName }}
        {{ $t('on') }}
        {{ formatDate(logMessages.deleted.date, 'DD/MM/YYYY HH:MM:SS') }}</label
      >
    </vs-row>
    <vs-row
      v-if="
        logMessages.classified.userName &&
        (statusId == 2 ||
          statusId == 4 ||
          statusId == 7)
      "
    >
      <label class="text-log">
        {{ $t('classified_by_e') }} {{ logMessages.classified.userName }}
        {{ $t('on') }} {{ logMessages.classified.date }}</label
      >
    </vs-row>
    <vs-row v-if="logMessages.approved.userName">
      <label class="text-log"
        >{{ $t('approved_by') }} {{ logMessages.approved.userName }}
        {{ $t('on') }} {{ logMessages.approved.date }}</label
      >
    </vs-row>
    <vs-row v-if="logMessages.paid.userName">
      <label class="text-log"
        >{{ $t('paid_by') }} {{ logMessages.paid.userName }} {{ $t('on') }}
        {{ logMessages.paid.date }}</label
      >
    </vs-row>
  </vs-col>
</template>

<script>
export default {
  props: {
    statusId: {
      type: [String,Number],
      default:'1',
    },
    logs:{
      type:Array,
      default:() => [],
    }
  },
  data() {
    return {
      logMessages: {
        classified: {
          userName: '',
          date: '',
        },
        created: {
          userName: '',
          date: '',
          comments: '',
        },
        deleted: {
          userName: '',
          date: '',
        },
        rejected: {
          userName: '',
          date: '',
        },
        approved: {
          userName: '',
          date: '',
        },
        paid: {
          userName: '',
          date: '',
        },
        canceled: {
          userName: '',
          date: '',
        },
      },
    }
  },
  methods: {
    setLogs() {
      this.logMessages.created.userName = ''
      this.logMessages.created.date = ''
      this.logMessages.classified.userName = ''
      this.logMessages.classified.date = ''
      this.logMessages.approved.userName = ''
      this.logMessages.approved.date = ''
      this.logMessages.paid.userName = ''
      this.logMessages.paid.date = ''
      this.logMessages.rejected.userName = ''
      this.logMessages.rejected.date = ''
      this.logMessages.canceled.userName = ''
      this.logMessages.canceled.date = ''
      this.logMessages.deleted.userName = ''
      this.logMessages.deleted.date = ''
        for (let i = 0; i < this.logs.length; i++) {
          if (this.logs[i].user) {
            if (this.logs[i].StatusId == 1) {
              this.logMessages.created.userName = this.logs[i].user.name
              this.logMessages.created.date = this.logs[i].created_at
              this.logMessages.created.comments = this.logs[i].Comments
            }
            if (this.logs[i].StatusId == 2) {
              this.logMessages.classified.userName = this.logs[i].user.name
              this.logMessages.classified.date = this.logs[i].created_at
            }
            if (this.logs[i].StatusId == 4) {
              this.logMessages.approved.userName = this.logs[i].user.name
              this.logMessages.approved.date = this.logs[i].created_at
            }
            if (this.logs[i].StatusId == 7) {
              this.logMessages.paid.userName = this.logs[i].user.name
              this.logMessages.paid.date = this.logs[i].created_at
            }
            if (this.logs[i].StatusId == 0) {
              this.logMessages.canceled.userName = this.logs[i].user.name
              this.logMessages.canceled.date = this.logs[i].created_at
            }
            if (this.logs[i].StatusId == 13) {
              this.logMessages.rejected.userName = this.logs[i].user.name
              this.logMessages.rejected.date = this.logs[i].created_at
            }
            if (this.logs[i].StatusId == 10) {
              this.logMessages.deleted.userName = this.logs[i].user.name
              this.logMessages.deleted.date = this.logs[i].created_at
            }
          }
        }
    },
  },
  watch: {
    logs() {
      if (this.logs.length) {
        this.setLogs()
      }
    },
  },
}
</script>

<style>
.text-log {
  color: #bc1300 !important;
  font-size: 14px !important;
}
</style>